import IframeView from './IframeView';

export default IframeView;
